var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "three-dots",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "three-dots-1",
    d: "M20 27.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5zm0-10c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5zm0-10c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "three-dots-2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "three-dots-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "three-dots-4",
    transform: "translate(-304.000000, -12.000000) translate(304.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "three-dots-5",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    id: "three-dots-6",
    xlinkHref: "#three-dots-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "three-dots-7",
    className: "fill-selector",
    fill: "#FFF308",
    mask: "url(#three-dots-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "three-dots-8",
    d: "M0 0H40V40H0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.04e2a682b73c3ae43e00aba99585f8d8.svg";
export { ForwardRef as ReactComponent };